import {
  createInvestorOrganization,
  updateInvestorOrganization,
  deleteInvestorOrganization,
} from './repository';

import {
  CREATE_ORGANIZATION_INIT,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_FAILURE,
  EDIT_ORGANIZATION_INIT,
  EDIT_ORGANIZATION_SUCCESS,
  EDIT_ORGANIZATION_FAILURE,
  DELETE_ORGANIZATION_INIT,
  DELETE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_FAILURE,
} from './types';

export const createOrganizationAction = data => async (dispatch) => {
  dispatch({ type: CREATE_ORGANIZATION_INIT });
  try {
    const response = await createInvestorOrganization(data);
    dispatch({ type: CREATE_ORGANIZATION_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: CREATE_ORGANIZATION_FAILURE, payload: error });
    throw error;
  }
};

export const editOrganizationAction = (id, data) => async (dispatch) => {
  dispatch({ type: EDIT_ORGANIZATION_INIT });
  try {
    const response = await updateInvestorOrganization(id, data);
    dispatch({ type: EDIT_ORGANIZATION_SUCCESS, payload: response });
    return response;
  } catch (error) {
    dispatch({ type: EDIT_ORGANIZATION_FAILURE, payload: error });
    throw error;
  }
};

export const deleteOrganizationAction = id => async (dispatch) => {
  dispatch({ type: DELETE_ORGANIZATION_INIT });
  try {
    await deleteInvestorOrganization(id);
    dispatch({ type: DELETE_ORGANIZATION_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_ORGANIZATION_FAILURE, payload: error });
    throw error;
  }
};
